import { render, staticRenderFns } from "./global-search-icon.vue?vue&type=template&id=ec7abfc0&scoped=true"
import script from "./global-search-icon.vue?vue&type=script&lang=js"
export * from "./global-search-icon.vue?vue&type=script&lang=js"
import style0 from "./global-search-icon.vue?vue&type=style&index=0&id=ec7abfc0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7abfc0",
  null
  
)

export default component.exports